import { Box, BoxProps, Text } from '@modusign/design-system';
import { ReactNode } from 'react';

interface ChipProps extends BoxProps<'div'> {
  children: ReactNode;
  color?: string;
}

export default function Chip({ children, color, ...props }: ChipProps) {
  return (
    <Box
      backgroundColor="statusBackgroundNeutralUltraLight"
      border="1px solid"
      borderColor="statusBorderNeutralLight"
      borderRadius="12px"
      minWidth="fit-content"
      ml={1}
      px="10px"
      py={1}
      {...props}
    >
      <Text
        color={color ?? 'textNeutralSlightlyLight'}
        fontSize={0}
        fontWeight="regular"
        whiteSpace="nowrap"
      >
        {children}
      </Text>
    </Box>
  );
}
